import React, { Component } from "react";
import { connect, useSelector } from "react-redux";
import { postDataAction } from "../config/redux/action";
import CSVReader from "react-csv-reader";
import { CSVLink } from "react-csv";
import { HeaderCompDocument } from "./Document/HeaderCompDocument";
import { Menu, Button } from "semantic-ui-react";
import {
  headersLaba,
  headersArus,
  headersNeraca,
  headersPegawai,
  dataPerusahaan,
} from "./Document/FormatCSV";
import { toast } from "react-toastify";
import LoadingTop from "../component/LoadingTop";

class Document extends Component {
  constructor() {
    super();
    this.state = {
      activeItemTop: "Laba/Rugi",
      isLoading: false,
      csvFile: {},
    };
  }

  handleItemClickMenuTop = (e, { name }) =>
    this.setState(
      {
        isLoading: true,
        activeItemTop: name,
      },
      () => {
        this.setState({
          isLoading: false,
        });
      }
    );

  handleForce = (data, fileInfo) => {
    this.setState({
      csvFile: {
        data: data,
        fileInfo: fileInfo,
      },
    });
  };

  handleSubmited = () => {
    const { activeItemTop, csvFile } = this.state;
    const pathAPI =
      activeItemTop === "Laba/Rugi"
        ? "laba-rugi/batch"
        : activeItemTop === "Neraca"
          ? "neraca/batch"
          : activeItemTop === "Arus Kas"
            ? "arus-kas/batch"
            : "pegawai/batch";

    const data = [...csvFile.data];
    try {
      // for (let d of data) {
      //   const temp = d.fixedAssets;
      //   if (temp === undefined) break;
      //   const fixedAssets = [];
      //   temp.split(",").forEach((fa) => {
      //     const o = fa.split("*");
      //     const name = o[0];
      //     const value = o[1] * 1;

      //   });
      //   d.fixedAssets = fixedAssets;
      // }
    } catch (e) {
      console.log(e);
      return;
    }

    this.props.postData({
      dispatch: "",
      title: activeItemTop,
      path: pathAPI,
      body: data,
    });
  };

  render() {
    const { activeItemTop, isLoading, csvFile } = this.state;
    const user = JSON.parse(localStorage.getItem("user")) || {};
    const perusahaanNama = user.perusahaan.nama;
    const papaparseOptions = {
      header: true,
      dynamicTyping: true,
      skipEmptyLines: true,
      transformHeader: (header) =>
        header.replace(/^\w/g, (c) => c.toLowerCase()).replace(/\W/g, ""),
    };

    const data = [];

    return (
      <>
        <HeaderCompDocument />
        <LoadingTop />
        <div className="container mt-3">
          <div className="row">
            <div className="col-md-12">
              <div className="card shadow-sm container py-3 border-0">
                <Menu pointing secondary className="menu--top">
                  {/* <Menu.Item
                    name="Anggaran"
                    color="green"
                    active={activeItemTop === "Anggaran"}
                    onClick={this.handleItemClickMenuTop}
                  /> */}
                  <Menu.Item
                    name="Laba/Rugi"
                    color="blue"
                    active={activeItemTop === "Laba/Rugi"}
                    onClick={this.handleItemClickMenuTop}
                  />
                  <Menu.Item
                    name="Neraca"
                    color="blue"
                    active={activeItemTop === "Neraca"}
                    onClick={this.handleItemClickMenuTop}
                  />
                  <Menu.Item
                    name="Arus Kas"
                    color="blue"
                    active={activeItemTop === "Arus Kas"}
                    onClick={this.handleItemClickMenuTop}
                  />
                  <Menu.Item
                    name="Pegawai"
                    color="blue"
                    active={activeItemTop === "Pegawai"}
                    onClick={this.handleItemClickMenuTop}
                  />
                </Menu>
                <div className="row mt-3">
                  <div className="col-md-4 d-flex">
                    <p className="my-auto mr-md-auto">Download Format CSV</p>
                    <p className="my-auto">:</p>
                  </div>
                  <div className="col-md-6 mt-md-0 mt-3">
                    {isLoading ? (
                      "isLoading"
                    ) : (
                      <CSVLink
                        data={data}
                        headers={
                          activeItemTop === "Laba/Rugi"
                            ? headersLaba
                            : activeItemTop === "Neraca"
                              ? headersNeraca
                              : activeItemTop === "Arus Kas"
                                ? headersArus
                                : activeItemTop === "Pegawai"
                                  ? headersPegawai
                                  : []
                        }
                        separator={";"}
                        filename={`Template Upload ${activeItemTop} ${perusahaanNama}.csv`}
                      >
                        <Button
                          size="mini"
                          content={`Download Template ${activeItemTop}`}
                          icon="download"
                          color="blue"
                          labelPosition="left"
                        />
                      </CSVLink>
                    )}
                  </div>
                  <div className="col-md-4 mt-4 d-flex align-items-center">
                    <p className="mr-md-auto">Upload File </p>
                    <p>:</p>
                  </div>
                  <div className="col-md-6 mt-4 d-flex align-items-center">
                    <div className="row">
                      <div className="col-md-10">
                        <CSVReader
                          cssClass="form-control"
                          label=""
                          onFileLoaded={this.handleForce}
                          parserOptions={papaparseOptions}
                        />
                      </div>
                      <div className="col-md-2">
                        {csvFile.data && (
                          <Button color="blue" onClick={this.handleSubmited}>
                            {" "}
                            Upload{" "}
                          </Button>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

const reduxDispatch = (dispatch) => ({
  postData: (data) => dispatch(postDataAction(data)),
});

export default connect(null, reduxDispatch)(Document);
